import { cn, PaletteUtils } from '@shared/utils';
import { Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

interface UserItemProps {
  className?: string;
  letter: string;
  name: string;
}

export const UserItem = (props: UserItemProps) => {
  return (
    <div
      className={cn(
        'relative flex w-full items-center justify-between gap-2 rounded p-3 pl-6 transition-colors duration-200',
        PaletteUtils.isInsigniaPalette && ['bg-white dark:bg-soft-black', 'hover:bg-gainsborough dark:hover:bg-transport-black'],
        PaletteUtils.isVcfcPalette && ['bg-ghost-white dark:bg-light/5', 'hover:bg-gainsborough dark:hover:bg-light/20'],
        props.className,
      )}
    >
      <div className='flex flex-shrink items-center gap-3'>
        <div className='flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-primary'>
          <div className='bg-accent flex h-full w-full items-center justify-center'>
            <Text weight='medium' size='2xl' color={PaletteUtils.isVcfcPalette ? 'white' : 'black'}>
              {props.letter}
            </Text>
          </div>
        </div>
        <div className='flex-1'>
          <Text className='line-clamp-1' weight='medium' size='lg'>
            {props.name}
          </Text>
        </div>
      </div>
      <div className='text-slate-60 flex h-6 w-6 items-center justify-center'>
        <Icon className='rotate-180' icon={<ChevronIcon />} />
      </div>
    </div>
  );
};
